
export const adapterOrdenesFromApi = ordenes_de_pago_from_api =>

    ordenes_de_pago_from_api.map(orden => {

        const { ejercicio, fechaPago, nroOrdenPago, beneficiario, imgPath, lote, importe, concepto, cuit, usuarioCargo, fechaCargo, nroInternoOrdenPago, codOrdenPago, habilitado, archivos } = orden

        return {
            ejercicio,
            fechaPago,
            nroOrdenPago,
            beneficiario,
            imgPath,
            lote,
            importe,
            concepto,
            cuit,
            usuarioCargo,
            fechaCargo,
            nroInternoOrdenPago,
            codOrdenPago,
            habilitado,
            archivos
        }
    })




export const toTableData = ordenes_de_pago => {

    return ordenes_de_pago.map(({ nroOrdenPago, importe, concepto, fechaPago, imgPath, archivos }, index) =>
    ({
        key: index,
        nro: nroOrdenPago,
        fecha: (fechaPago.split('T')[0]),
        importe,
        concepto,
        archivos: archivos.map(({ fileName, fileExtension }) =>
        ({
            name: fileName,
            extension: fileExtension,
            path: imgPath,
        })
        )
    })
    )
}

/*
export const toTableData = ordenes_de_pago => {

    const ordenes_de_pago_agrupadas = agruparOrdenesDePago(ordenes_de_pago)

    return Object.keys(ordenes_de_pago_agrupadas).map((nro_orden, index) =>
    ({
        key: index,
        nroOrden: nro_orden,
        fecha: moment(ordenes_de_pago_agrupadas[nro_orden].fecha),
        total: ordenes_de_pago_agrupadas[nro_orden].total
    })
    )
}


const agruparOrdenesDePago = (ordenes_de_pago) =>

    ordenes_de_pago.reduce((acc, { nroOrdenPago, fechaPago, importe, imgPath }) => {

        let data = acc[nroOrdenPago]

        if (!data)
            acc[nroOrdenPago] =
            {
                fecha: fechaPago,
                total: importe,
                imgs: [imgPath]
            };

        else acc[nroOrdenPago] = {
            ...data,
            total: data.total + importe,
            imgs: [...data.imgs, imgPath]
        }
        return acc;
    }, {});

    */